import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import DateUtil from "gw-portals-util-js/DateUtil";

var fn = function fn($window, $translate, $scope, $rootScope, $state, $filter, $q, $stateParams, ModalService, PolicyService, ViewModelService, CancellationService) {

	$scope.policyNumber = $stateParams.policyNumber;
	$scope.jobNumber = $stateParams.jobNumber;
	$scope.selectedData = $stateParams.data;
	$scope.effDate = $stateParams.effDate;
	$scope.jobStatus = $stateParams.status;
	$rootScope.portalCoveredEmployees = null;
	$scope.locationMissing = false;
	$scope.withdrawSubmitted = false;
	$scope.newAddition = false;
	$rootScope.policyBound = false;
	$rootScope.restrictNavigation = true;
	$rootScope.restrictNavigationStatus = true;
	$rootScope.policyQuotedStatus = false;
	// Empty the state listeners during controller startup
	$rootScope.$$listeners.$stateChangeStart = [];
	$scope.namedInsuredMailingAddress = '';
	$scope.mailingOldValue = '';
	$scope.mailingNewValue = '';
	$scope.companyName = '';
	$scope.oldMSFWCCoveredEmployees = [];

	var policyDetails = PolicyService.getAccountPolicyDetails($stateParams.policyNumber);
	policyDetails.then(function (res) {
		var selectedPeriod = res.currentPeriod;
		var namedInsuredContact = selectedPeriod.contacts.find(function (a) {
			return a.contactRole === 'Named Insured';
		});
		if (namedInsuredContact && namedInsuredContact.contact && namedInsuredContact.contact.primaryAddress) {
			var namedInsuredMailingAddressValue = namedInsuredContact.contact.primaryAddress;
			$scope.namedInsuredMailingAddress = ViewModelService.create(namedInsuredMailingAddressValue, 'pc', 'edge.capabilities.address.dto.MSFPolicyLocationDTO');
		}
	});
	if ($stateParams.periodData != null && $stateParams.periodData != undefined && $stateParams.periodData != 'periodData') {
		$scope.periodData = $stateParams.periodData;
	} else {
		PolicyService.findChangeJobByNumber($scope.jobNumber).then(function (data) {
			$scope.periodData = data.latestPeriod;
			if ($scope.periodData.mSFWCCoveredEmployees.length > 0) {
				$scope.periodData.mSFWCCoveredEmployees = data.latestPeriod.mSFWCCoveredEmployees;
				$scope.oldMSFWCCoveredEmployees = JSON.parse(JSON.stringify($scope.periodData.mSFWCCoveredEmployees));
			}
			if ($scope.periodData.mSFAddWCCoveredEmployees.length > 0) {
				$scope.periodData.mSFAddWCCoveredEmployees = data.latestPeriod.mSFAddWCCoveredEmployees;
			}
			//Merge all classcode's basic amount if split is happened
			if ($scope.periodData.mSFWCCoveredEmployees.length > 0 && $scope.periodData.mSFAddWCCoveredEmployees.length > 0) {
				$scope.period = [];
				angular.forEach($scope.periodData.mSFWCCoveredEmployees, function (allVersions) {
					angular.forEach($scope.periodData.mSFAddWCCoveredEmployees, function (additionalVersions) {
						if (allVersions.classCode.code == additionalVersions.classCode.code && allVersions.location.locationNum == additionalVersions.location.locationNum) {
							allVersions.basisAmount = allVersions.basisAmount + additionalVersions.basisAmount;
						}
					});
					$scope.period.push(allVersions);
				});
				$scope.oldMSFWCCoveredEmployees = JSON.parse(JSON.stringify($scope.period));
				$scope.periodData.mSFWCCoveredEmployees = $scope.period;
			}
		});
	}

	//fetch EL Limit Data
	getELLimitData();

	/**
  * Get EL Limit Options
  * @params {none} - Calls the get ELLimitOptions from PolicyService with Jobnumber after the quote has been completed.
  * @returns {Populated $scope Object} - sets employersLiability, empoloyersLiabilitys, primaryInsured,
  *                                       adjPremium, premiumDifference and quoteELLLimit.
  * @private
  **/
	function getELLimitData() {
		PolicyService.getElLimitOptions($scope.jobNumber).then(function (data) {
			if ($scope.jobStatus == "Quoted") {
				$scope.policyQuoted = true;
				$rootScope.policyQuotedStatus = true;
			}
			$scope.employersLiability = data.termOption;
			$scope.employersLiabilitys = data.msfSelectedValue_Ext;
			$scope.oldEmployersLiabilitys = data.msfSelectedValue_Ext;
			$scope.primaryInsured = data.msfPrimaryInsured_Ext;

			$scope.adjPremium = data.mSFPremium_Ext;
			if ($scope.adjPremium != undefined && $scope.curPremium != undefined && $scope.adjPremium.amount != undefined && $scope.curPremium.amount != undefined) {
				var pre = roundToTwo($scope.adjPremium.amount - $scope.curPremium.amount);
				$scope.premiumDifference = { "currency": "usd", "amount": pre };
			}
			//In case the policy change is quoted
			//var data=angular.element(document.querySelector( '#empLiability' )).val();
			$scope.quoteELLimit = data.msfSelectedValue_Ext;
		}, function () {
			ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
		});
	}

	var policyRequest = PolicyService.getPolicy($stateParams.policyNumber);
	policyRequest.then(function (policy) {
		var period = policy.latestActivePeriod;
		console.log("getpolicy");
		console.log(policy);

		$scope.mSFAddresses = policy.mSFAddresses;
		$scope.curPremium = period.totalCost;
		if ($scope.adjPremium != undefined && $scope.curPremium != undefined && $scope.adjPremium.amount != undefined && $scope.curPremium.amount != undefined) {
			var pre = roundToTwo($scope.adjPremium.amount - $scope.curPremium.amount);
			$scope.premiumDifference = { "currency": "usd", "amount": pre };
		} else {
			//call getELLimitData function
			getELLimitData();
		}
	});

	/**
  * Function : Check for Specific waiver of subrogation is already added to the job, if it exists update the scope object.
  * @params{Object} - $scope.jobNumber
  * @returns{Object} - $scope object is populated with values. CompanyName, Address, QuoteAdditionalInfo, PostalCode and PublicId
  * @private
  **/
	$scope.swosCheck = function () {
		// Check whether SWOS is already added to the jobNumber
		var SWOSExist = PolicyService.getExistingSWOS($scope.jobNumber);
		SWOSExist.then(function (res) {
			if (res.sWOSExists != undefined && res.sWOSExists) {
				$scope.JOBSWOSPresent = true;
				$scope.quoteCompanyName = res.companyName;
				$scope.quoteAddressLine1 = res.addressLine1;
				$scope.quoteAddressLine2 = res.addressLine2;
				$scope.quoteAddressLine3 = res.addressLine3;
				$scope.quoteCity = res.city;
				$scope.quoteState = res.state;
				$scope.quoteAdditionalInfo = res.additionalInfo;
				$scope.quotePostalCode = res.postalCode;
				$scope.quoteCounty = res.county;
				$scope.swosPublicId = res.publicId;
			} else if (res.existingSWOS != undefined && res.existingSWOS) {
				$scope.JOBSWOSPresent = true;
				$scope.quoteCompanyName = res.companyName;
				$scope.quoteAddressLine1 = res.addressLine1;
				$scope.quoteAddressLine2 = res.addressLine2;
				$scope.quoteAddressLine3 = res.addressLine3;
				$scope.quoteCity = res.city;
				$scope.quoteState = res.state;
				$scope.quoteAdditionalInfo = res.additionalInfo;
				$scope.quotePostalCode = res.postalCode;
				$scope.quoteCounty = res.county;
				$scope.swosPublicId = res.publicId;
			} else {
				$scope.JOBSWOSPresent = false;
			}
		}, function () {
			//no data returned...just set the JOBSWOSPresent to false
			$scope.JOBSWOSPresent = false;
		});
	};

	/**  Quote Policy Change **/
	function quotepolicyChange(showError) {

		PolicyService.quotePolicyChange($scope.jobNumber).then(function (data) {
			$scope.quotePolicyChangeInProgress = false;
			$scope.disableSubmit = false;
			$scope.policyQuoted = true;
			$rootScope.policyQuotedStatus = true;
			var limitValue = angular.element(document.querySelector('#empLiability')).val();
			$scope.quoteELLimit = limitValue.toString().substring(7);
			$scope.adjPremium = data;
			if ($scope.adjPremium != undefined && $scope.curPremium != undefined && $scope.adjPremium.amount != undefined && $scope.curPremium.amount != undefined) {
				var pre = roundToTwo($scope.adjPremium.amount - $scope.curPremium.amount);
				$scope.premiumDifference = { "currency": "usd", "amount": pre };
			}
		}, function () {
			$scope.quotePolicyChangeInProgress = false;

			$scope.disableSubmit = false;
			$scope.errorInSubmission = true;
			$rootScope.restrictNavigation = false;
			$rootScope.restrictNavigationStatus = false;
			if (showError === true) {
				ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
			}
		});
	}
	$scope.quotePolicyChange = function (companyData) {
		$scope.companyName = companyData && companyData.CompanyName;
		$scope.disableSubmit = true;
		//Check SWOS
		$scope.swosCheck();

		//If ChangeEstimatedPresent is true then
		if ($scope.CEWPresent) {
			/**
    * Calls UpdateCoveredEmployees service and quotePolicyChange Service
    **/
			PolicyService.updateCoveredEmployees($scope.jobNumber, $rootScope.portalCoveredEmployees, $scope.periodData.mSFWCCoveredEmployees).then(function (updatedData) {
				quotepolicyChange(true);
			});
		} else {
			/**
    * Calls quotePolicyChange Service only.
    **/
			$scope.quotePolicyChangeInProgress = true;

			quotepolicyChange(false);
		}
	};
	/** Quote and Bind Policy Change **/

	/**
  * Function : Calls PolicyService.quoteAndBindPolicyChange, Quotes and binds the policy, if there is a location
  *            creates an activity and then navigates to the PolicyDetail screen.
  * @params{Object} : $scope.jobNumber
  * @returns{Object} : Quoted and Bound Submission/Policy.
  * @private
  **/
	$scope.quoteAndBindPolicyChange = function () {
		$scope.disableSubmit = true;
		PolicyService.quoteAndBindPolicyChange($scope.jobNumber).then(function (res) {
			console.log("QuoteandBindPolicyChange");
			console.log(res);
			$rootScope.restrictNavigation = false;
			$rootScope.restrictNavigationStatus = false;
			$rootScope.policyBound = true;
			if ($scope.EMAPresent) {
				createActivityForMailingAddress();
			} else if ($scope.LocationPresent) {
				createActivity();
				//restore defaults....
				$scope.savedIndex = -1;
			}
			$scope.withdrawSubmitted = false;
			//route to the policy details page to show the confirmation message.
			$state.go('account-policy-details', {
				policyNumber: $scope.policyNumber
			});
		}, function () {
			// There was a problem during Quote and Bind process, set errorInSubmission Flag to true and display error message.
			$scope.errorInSubmission = true;
			$rootScope.restrictNavigation = false;
			$rootScope.restrictNavigationStatus = false;
			ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
		});
	};

	/**
  * Function : Keeps track of emitted event initiateQuoteAndBind to execute quoteAndBindPolicyChange() Method.
  * @params{none}
  * @returns{none} - executes function.
  * @private
  **/
	$scope.$on("initiateQuoteAndBind", function () {
		$scope.quoteAndBindPolicyChange();
	});
	//Enable and disabling quote in CEW
	$scope.enableCEWQuote = true;

	/**
  * Function : Keeps track of emitted event enableCEWQuote to set flag enableCEWQuote to true.
  * @params{none}
  * @returns{none} - sets flag to true on Scope object
  * @private
  **/
	$scope.$on("enableCEWQuote", function () {
		$scope.enableCEWQuote = true;
	});
	/**
  * Function : Keeps track of emitted event disableCEWQuote to setflag enableCEWQuote to false.
  * @params{none}
  * @returns{none} - sets flag to false on Scope object
  * @private
  **/
	$scope.$on("disableCEWQuote", function () {
		$scope.enableCEWQuote = false;
	});

	/**  Bind Policy Change **/
	$scope.bindPolicyChange = function () {
		$scope.disableSubmit = true;
		/**
   * Function : Calls PolicyService.bindPolicyChange, Binds the policyChange transaction, then navigates to the PolicyDetail Summary screen.
   * @params{Object} : $scope.jobNumber
   * @returns{Object} : Quoted and Bound Submission/Policy.
   * @private
   **/
		PolicyService.bindPolicyChange($scope.jobNumber).then(function (data) {
			$rootScope.policyBound = true;
			$rootScope.restrictNavigation = false;
			$rootScope.restrictNavigationStatus = false;
			$scope.withdrawSubmitted = false;

			if ($scope.CEWPresent) {
				var editedClassCode = [];
				var addedClassCode = [];

				$rootScope.addEditedClassCodeList.forEach(function (obj) {
					if (obj.isNew) {
						addedClassCode.push({
							code: obj.classCode.code,
							oldWage: obj.basisAmount,
							newWage: 0
						});
					} else {
						var oldClassData = $scope.oldMSFWCCoveredEmployees.find(function (a) {
							return a.classCode.code == obj.classCode.code;
						});
						if (oldClassData && obj.basisAmount != oldClassData.basisAmount) {
							editedClassCode.push({
								code: oldClassData.classCode.code,
								oldWage: oldClassData.basisAmount,
								newWage: obj.basisAmount
							});
						}
					}
				});
				createActivityForPolicyChangeOptions('', '', 'Change Estimated Wages/Add or Edit a Class Code', '', '', addedClassCode, editedClassCode);
			} else if ($scope.ELPresent) {
				if ($scope.oldEmployersLiabilitys != $scope.newEmployersLiabilitys) {
					createActivityForPolicyChangeOptions($scope.oldEmployersLiabilitys, $scope.newEmployersLiabilitys, 'Change Employers Liability Limit');
				}
			} else if ($scope.SWOSPresent) {
				var selectedSWOS = $scope.selectedData[0];
				var effectiveDate = $scope.effDay + ' ' + $scope.effMonth + ' ' + $scope.effYear;
				createActivityForPolicyChangeOptions('', '', selectedSWOS, $scope.companyName, effectiveDate);
			}

			$state.go('policies.detail.summary', {
				'policyNumber': $scope.policyNumber
			});
		}, function () {
			$scope.errorInSubmission = true;
			$rootScope.restrictNavigation = false;
			$rootScope.restrictNavigationStatus = false;
			ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
		});
	};
	/**  Initiate Quote policy change **/
	$scope.$on("initiateQuote", function (event, companyData) {
		$scope.quotePolicyChange(companyData);
	});

	/**  Set EL Limit **/
	/**
  * Function : Set EL Limit
  * @params{Boolean}
  * @returns{Boolean} - sets value on $scope.ELChanged to whatever value is passed in.
  * @private
  **/
	$scope.setELlimit = function (data) {
		var codeSelected = 0;
		angular.forEach($scope.employersLiability, function (res) {
			if (data == res.name) codeSelected = res.name;
		});
		if (codeSelected != 0) {
			$scope.newEmployersLiabilitys = codeSelected;
			PolicyService.setElLimitOption($scope.jobNumber, data).then(function (data) {
				if (data == true) {
					$scope.ELChanged = true;
				} else {
					$scope.ELChanged = false;
				}
				if (!data) {
					console.log("limit update-error");
				}
			}, function () {
				ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
			});
		}
	};
	/**
  * Function Redirects view to SWOS tab and highlights the SWOS tab
  * @params{none}
  * @returns{none} - updates html element SWOS directly.
  * @private
  **/
	$scope.$on("SWOSPrevious", function () {
		$scope.redirectPrevious('SWOS');
	});

	if ($scope.selectedData != undefined && $scope.selectedData.constructor === Array) {
		$scope.SWOSOnlyPresent = false;
		angular.forEach($scope.selectedData, function (res) {
			if (res == $filter('translate')('gateway.controllers.policy.policychange.Change Employers Liability Limit')) {
				$scope.ELPresent = "true";
			}
			if (res == $filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation')) {
				$scope.LocationPresent = "true";
			}
			if (res == $filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) {
				$scope.SWOSPresent = "true";
			}
			if (res == $filter('translate')('directives.policy-change.Estimated Wages')) {
				$scope.CEWPresent = "true";
			}
			if (res == $filter('translate')('gateway.directives.policy-change.Mailing Address')) {
				$scope.EMAPresent = "true";
			}
		});
	} else if ($scope.selectedData != undefined && $scope.selectedData.constructor != Array) {
		$scope.SWOSOnlyPresent = false;
		if ($scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Change Employers Liability Limit')) !== -1) {
			$scope.ELPresent = "true";
		}
		if ($scope.selectedData.indexOf($filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation')) !== -1) {
			$scope.LocationPresent = "true";
		}
		if ($scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) !== -1) {
			$scope.SWOSPresent = "true";
		}
		if ($scope.selectedData.indexOf($filter('translate')('directives.policy-change.Estimated Wages')) !== -1) {
			$scope.CEWPresent = "true";
		}
		if ($scope.selectedData.indexOf("Blanket Waiver of Subrogation") !== -1) {
			$scope.selectedDataDescription = "Blanket Waiver of Subrogation";
		}
		if ($scope.selectedData.indexOf($filter('translate')('gateway.directives.policy-change.Mailing Address')) !== -1) {
			$scope.LocationPresent = "true";
			$scope.EMAPresent = "true";
		}
		$scope.selectedData = $scope.selectedData.split(",");
	}

	if ($scope.selectedData != undefined && $scope.selectedData.length == 1 && $scope.SWOSPresent == "true") {
		$scope.SWOSOnlyPresent = true;
	}
	/**
  * Function Highlights the ELLimit tab and removes highlights from SWOS, CEW, COI and Locations tab
  * @params{none}
  * @returns{none} - updates html element ELLimit directly.
  * @private
  **/
	function ELScreenSelect() {
		var changeColor = angular.element(document.querySelector('#ElLimit'));
		changeColor.removeClass('wizard-tile');changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile-blue');
		var change = angular.element(document.querySelector('#Locations'));
		change.removeClass('wizard-tile');change.removeClass('wizard-tile-blue');
		change.addClass('wizard-tile');
		var changeColor = angular.element(document.querySelector('#SWOS'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
	}
	/**
  * Function Highlights the Locations tab and removes highlights from SWOS, ELLimit, COI and CEW tab
  * @params{none}
  * @returns{none} - updates html element Locations directly.
  * @private
  **/
	function LocationsSelect() {
		var changeColor = angular.element(document.querySelector('#Locations'));
		changeColor.removeClass('wizard-tile');changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile-blue');
		var changeColor = angular.element(document.querySelector('#ElLimit'));
		changeColor.removeClass('wizard-tile');changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
		var changeColor = angular.element(document.querySelector('#SWOS'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
		var change = angular.element(document.querySelector('#MailingAddress'));
		change.removeClass('wizard-tile');
		change.removeClass('wizard-tile-blue');
		change.addClass('wizard-tile-blue');
	}
	//DEF - 0431 and 0432
	/**
  * Function formats the location object's address information is the business required format
  * @params{Object} Location
  * @returns{String} - Address in business requred format.
  * @private
  **/
	function getAddressDetails(loc) {
		if (loc !== undefined) {
			return loc.addressLine1 + " " + loc.addressLine2 + " " + loc.city + ", " + loc.state + " " + loc.postalCode;
		}
	}

	/**
  * Function : creates and Activity when editing an Existing location. Calls createActivityForLocationChange via Policy Service
  * @params{String, String, String } - policyNumber, oldLocation, newLocation
  * @returns{None} - creates activity.
  * @private
  **/
	function createActivity() {
		// We are Not generating activity for a new Location, instead only creating one when editing an existing location.
		if ($scope.LocationPresent && !$scope.newAddition) {
			// get the currently selected location and get the new value..
			$scope.locationsExist = function () {
				return $scope.policyLocations && !($scope.policyLocations.length === 0);
			};
			if ($scope.locationsExist && $scope.oldLocation && $scope.selectedEntry != undefined && $scope.selectedLocation !== undefined) {
				var newValue = getAddressDetails($scope.editedLocation);
				console.log('new location');
				console.log(newValue);
				var oldValue = getAddressDetails($scope.oldLocation);
				console.log('old location');
				console.log(oldValue);
				PolicyService.createActivityForLocationChange($scope.policyNumber, oldValue, newValue).then(function (data) {
					console.log(data);
				}, function () {
					console.log("Activity could not be created..");
				});
			}
		}
	}

	/**
     * Function : creates and Activity when editing an Existing Mailing Address. Calls createActivityForMailingAddress via Policy Service
     * @params{String, String, String } - policyNumber, mailingoldvalue, mailingnewvalue
     * @returns{None} - creates activity.
     * @private
     **/
	function createActivityForMailingAddress() {

		if ($scope.mailingOldValue !== $scope.mailingNewValue) {
			//Fixed the wrong old value and new value issue in activity
			var newValue = $scope.mailingNewValue;
			console.log('new location');
			console.log(newValue);
			var oldValue = $scope.mailingOldValue;
			console.log('old location');
			console.log(oldValue);
			PolicyService.createActivityForMailingAddressChange($scope.policyNumber, oldValue, newValue).then(function (data) {
				console.log(data);
			}, function () {
				console.log("Activity could not be created..");
			});
		}
	}

	function createActivityForPolicyChangeOptions(oldValue, newValue, policyChangeType, companyName, effectiveDate, newClassCodeList, editedClassCodeList) {

		PolicyService.createActivityForPolicyChangeOptions($scope.jobNumber, $scope.policyNumber, oldValue, newValue, policyChangeType, companyName, effectiveDate, newClassCodeList, editedClassCodeList).then(function (data) {
			console.log(data);
		}, function () {
			console.log("Activity could not be created..");
		});
	}
	/**
  * Function Highlights the CEW tab and removes highlights from SWOS, ELLimit, COI and Locations tab
  * @params{none}
  * @returns{none} - updates html element CEW directly.
  * @private
  **/
	function CEWSelect() {
		var changeColor = angular.element(document.querySelector('#CEW'));
		changeColor.removeClass('wizard-tile');changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile-blue');
		var changeColor = angular.element(document.querySelector('#SWOS'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
		var changeColor = angular.element(document.querySelector('#ElLimit'));
		changeColor.removeClass('wizard-tile');changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
		var change = angular.element(document.querySelector('#COI'));
		change.removeClass('wizard-tile');change.removeClass('wizard-tile-blue');
		change.addClass('wizard-tile');
		var change = angular.element(document.querySelector('#Locations'));
		change.removeClass('wizard-tile');change.removeClass('wizard-tile-blue');
		change.addClass('wizard-tile');
	}
	/**
  * Function Highlights the SWOS tab and removes highlights from CEW, ELLimit, COI and Locations tab
  * @params{none}
  * @returns{none} - updates html element SWOS directly.
  * @private
  **/
	function SWOSSelect() {
		$scope.disableSubmit = true;
		var changeColor = angular.element(document.querySelector('#SWOS'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile-blue');
		var changeColor = angular.element(document.querySelector('#Locations'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
		var changeColor = angular.element(document.querySelector('#ElLimit'));
		changeColor.removeClass('wizard-tile');
		changeColor.removeClass('wizard-tile-blue');
		changeColor.addClass('wizard-tile');
	}

	if ($scope.ELPresent) {
		ELScreenSelect();
		$scope.SWOSScreen = false;
		$scope.locationScreen = false;
		$scope.ELScreen = true;
	} else if ($scope.LocationPresent) {
		LocationsSelect();
		$scope.locationScreen = true;
		$scope.SWOSScreen = false;
		$scope.ELScreen = false;
	} else if ($scope.SWOSPresent) {
		SWOSSelect();
		$scope.SWOSScreen = true;
		$scope.locationScreen = false;
		$scope.ELScreen = false;
	} else if ($scope.CEWPresent) {
		CEWSelect();
		$scope.CEWScreen = true;
		$scope.ELScreen = false;
		$scope.COIScreen = false;
		$scope.locationScreen = false;
		$scope.SWOSScreen = false;
	} else if ($scope.EMAPresent) {
		EMASelect();
		$scope.EMAScreen = true;
		$scope.locationScreen = false;
		$scope.ELScreen = false;
		$scope.COIScreen = false;
		$scope.CEWScreen = false;
		$scope.SWOSScreen = false;
	}

	var ctrl = Object.create(BaseCtrl);
	if ($scope.SWOSPresent) {
		var fullDate = DateUtil.currentDate();
		if (fullDate != undefined) {
			fullDate.setDate(fullDate.getDate() + 1);
			$scope.effDay = fullDate.getDate();
			$scope.effMonth = fullDate.toLocaleString('default', { month: 'long' });
			$scope.effYear = fullDate.getFullYear();
		}
	} else {
		var fullDate = formatDate(new Date($scope.effDate));
		if (fullDate != undefined) {
			fullDate = fullDate.split(',');
			$scope.effDay = fullDate[0];
			$scope.effMonth = fullDate[1];
			$scope.effYear = fullDate[2];
		}
	}

	/**
  * Function description
  * @params{String} - JobNumber
  * @returns{Object} = policyLocations list
  * @private
  **/
	PolicyService.getLocationsForPolicy($scope.jobNumber).then(function (data) {
		if ($scope.jobStatus == "Quoted") {
			$scope.policyQuoted = true;
			$rootScope.policyQuotedStatus = true;
		}
		$scope.policyLocations = data;
	}, function () {
		ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
	});
	/**
  * Function : Withdraw a PolicyChange transaction. Calls withdrawPolicyTransaction via Policy Service.
  * @params{String, String} : policyNumber, jobNumber
  * @returns{void} : withdraws transaction, if successful - sets withdrawsubmitted to true for both the rootScope and Scope objects.
  * @private
  **/
	$scope.withdraw = function () {
		var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this policy change?', '', 'Withdraw', '', 'Cancel').result;
		withdrawModal.then(function (res) {
			$scope.$broadcast("withdrawSubmitted");
			var withdrawPromise = PolicyService.withdrawPolicyTransaction($scope.policyNumber, $scope.jobNumber);
			withdrawPromise.then(function (res) {
				$rootScope.withdrawSubmitted = true;
				$rootScope.policyBound = false;
				$rootScope.restrictNavigation = false;
				$rootScope.restrictNavigationStatus = false;
				$scope.withdrawSubmitted = true;

				$state.go('policies.detail.summary', {
					'policyNumber': $scope.policyNumber
				});
			});
		});
	};
	/**
  * Function Called from html page to indicate exiting out of current page onto the next specified page.
  * @params{String} - policyNumber
  * @returns{None} - changes state to PolicyDetailSummary page.
  * @private
  **/
	$scope.saveExit = function () {
		$state.go('policies.detail.summary', {
			'policyNumber': $scope.policyNumber
		});
	};
	/**
  * Function sets variable for locationScreen to true
  * @params{}
  * @returns{}
  * @private
  **/
	$scope.locationScreens = function () {
		LocationsSelect();
		$scope.locationScreen = true;
		$scope.ELScreen = false;
		$scope.SWOSScreen = false;
	};
	/**
  * Function : sets variable for ELScreen to true
  * @params{}
  * @returns{}
  * @private
  **/
	$scope.ELScreens = function () {
		ELScreenSelect();
		$scope.SWOSScreen = false;
		$scope.locationScreen = false;
		$scope.ELScreen = true;
	};
	//Highlight CEW View
	$scope.CEWScreens = function () {
		$scope.locationMissing = false;
		if ($scope.LocationPresent) {
			/**
    * Function : Highlights CEW screen
    * @params{String} JobNumber required for getLocationsForPolicyMethod...
    * @returns{Array} List of locations
    * @private
    **/
			CancellationService.getLocationsForPolicy($scope.jobNumber).then(function (data) {
				$scope.periodData.mSFLocations = data;
				CEWSelect();
				$scope.COIScreen = false;
				$scope.locationScreen = false;
				$scope.ELScreen = false;
				$scope.SWOSScreen = false;
				$scope.CEWScreen = true;
			});
		} else {
			CEWSelect();
			$scope.COIScreen = false;
			$scope.locationScreen = false;
			$scope.ELScreen = false;
			$scope.SWOSScreen = false;
			$scope.CEWScreen = true;
		}
	};

	/**
  * Function : Highlights SWOS Screen
  * @params{}
  * @returns{} - sets value on Scope Object for SWOSScreen value to true
  * @private
  **/
	$scope.SWOSScreens = function () {
		SWOSSelect();
		$scope.disableSubmit = true;
		$scope.SWOSScreen = true;
		$scope.locationScreen = false;
		$scope.ELScreen = false;
	};
	/**
  * Function that determines if the user can proceed to the next screen.
  * @params{String} - type of screen
  * @returns{Boolean}
  * @private
  **/
	$scope.confirmNext = function (screen) {
		if (screen === 'EL') {
			if ($scope.CEWPresent || $scope.LocationPresent || $scope.COIPresent || $scope.SWOSPresent || $scope.EMAPresent) {
				return true;
			} else false;
		} else if (screen === 'locations') {
			if ($scope.SWOSPresent) {
				return true;
			}
		} else if (screen === 'COI') {
			if ($scope.SWOSPresent || $scope.CEWPresent) {
				return true;
			}
		} else if (screen === 'SWOS') {
			if ($scope.CEWPresent) {
				return true;
			}
		}
		return false;
	};
	/**
  * Function that redirects to a specific screen and highlights that screen
  * @params{String} - Screen type
  * @returns{Object} navigates to specific screen
  * @private
  **/
	$scope.redirectNext = function (screen) {
		if (screen === 'EL') {
			if ($scope.LocationPresent) {
				$scope.nextScreen = 'locations';
				$scope.locationScreens();
			} else if ($scope.SWOSPresent) {

				$scope.nextScreen = 'SWOS';
				$scope.SWOSScreens();
			} else if ($scope.CEWPresent) {
				$scope.nextScreen = 'CEW';
				$scope.CEWScreens();
			} else if ($scope.EMAPresent) {
				$scope.nextScreen = 'mailingAddress';
				$scope.EMAScreens();
			}
		} else if (screen === "locations") {
			// DEF1315 save changes while navigating to next screen
			$scope.saveChangesForNext();
			if ($scope.SWOSPresent) {

				$scope.nextScreen = 'SWOS';
				$scope.SWOSScreens();
			} else if ($scope.CEWPresent) {
				$scope.nextScreen = 'CEW';
				$scope.CEWScreens();
			}
		}
		//for SWOS
		else if (screen === 'SWOS') {
				if ($scope.CEWPresent) {
					$scope.nextScreen = 'CEW';
					$scope.CEWScreens();
				}
			}
	};
	/**
  * Function : redirects to previous screens
  * @params{String} - type of screen
  * @returns{object} - specific view.
  * @private
  **/
	$scope.redirectPrevious = function (screen) {
		if (screen === 'locations') {
			if ($scope.ELPresent) {
				$scope.ELScreens();
			}
		} else if (screen === 'COI') {
			if ($scope.LocationPresent) {
				$scope.locationScreens();
			} else if ($scope.ELPresent) {
				$scope.ELScreens();
			}
		} else if (screen === 'SWOS') {
			$scope.disableSubmit = false;
			if ($scope.LocationPresent) {
				$scope.locationScreens();
			} else if ($scope.ELPresent) {
				$scope.ELScreens();
			}
		} else if (screen === 'CEW') {
			if ($scope.SWOSPresent) {
				$scope.SWOSScreens();
			} else if ($scope.COIPresent) {
				$scope.COIScreens();
			} else if ($scope.LocationPresent) {
				$scope.locationScreens();
			} else if ($scope.ELPresent) {
				$scope.ELScreens();
			}
		}
	};
	/**
  * Check whether vehicles exist
  *
  * @returns {boolean}
  */
	$scope.locationsExist = function () {
		return $scope.policyLocations && !($scope.policyLocations.length === 0);
	};

	/**
  * Check whether only one location exists
  *
  * @returns {boolean}
  */
	$scope.onlyOnelocationsExists = function () {
		return $scope.policyLocations && $scope.policyLocations.length === 1;
	};

	/**
  * Begin editing an entry
  */
	$scope.onEdit = function () {
		ctrl.cleanAdd();
		ctrl.resetFlags();
		$scope.isEditing = true;
	};
	$scope.inPreCommitStage = function () {
		return $scope.isAddingNew || ($scope.isEditing || $scope.isRemoving) && $scope.selectedEntry > -1;
	};

	/**
  * Select an entry
  *
  * @param {Number}
  *            index
  */
	$scope.selectEntry = function (index, location) {
		console.log('in selected Entry');
		console.log('index value' + index);
		console.log('is editing value' + $scope.isEditing);
		var locations = $scope.policyLocations;

		var locationView = locations[index];
		$scope.locationView = locations[index];
		$scope.selectedLocation = locationView;
		$scope.locationView = ViewModelService.create($scope.selectedLocation, 'pc', 'edge.capabilities.address.dto.MSFPolicyLocationDTO');
		$scope.selectedEntry = index;
		$scope.savedIndex = index;
		//Fixed the wrong old value and new value issue in activity
		if ($scope.isEditing && !$scope.oldLocation) {
			$scope.oldLocation = angular.copy(locations[index]);
			$scope.editedLocation = locationView;
		}
		console.log('old location');
		console.log($scope.oldLocation);
	};
	/**
  * Select primary
  *
  * @param {Number}
  *            index
  */
	$scope.selectPrimary = function (index) {
		$scope.selectedPrimary = index;
		var locationIndex = 0;
		angular.forEach($scope.policyLocations, function (value, key) {
			if (locationIndex == $scope.selectedPrimary) {
				$scope.policyLocations[locationIndex].primaryLocation = true;
			} else {
				$scope.policyLocations[locationIndex].primaryLocation = false;
			}
			locationIndex++;
		});
		if ($scope.policyLocations[$scope.selectedPrimary].actionType != 'add') {
			$scope.policyLocations[$scope.selectedPrimary].actionType = 'updatePrimary';
		}
		//ctrl.saveChanges($scope.policyLocations[$scope.selectedPrimary], 'updatePrimary');
	};
	/**
  * Cancels add operation if they are active
  */
	ctrl.cleanAdd = function () {

		if ($scope.isAddingNew) {
			$scope.cancelNewEntry();
		}
	};

	/**
  * Begin adding a new entry
  */
	$scope.onAddNew = function () {
		ctrl.cleanAdd();
		setDefaultNewEntry();
		ctrl.resetFlags();
		$scope.isAddingNew = true;
	};
	/**
  * Begin removing entries
  */
	$scope.onRemove = function () {
		ctrl.cleanAdd();
		ctrl.resetFlags();
		$scope.isRemoving = true;
	};

	/**
  * Delete an entry
  *
  * @param {Number}
  *            index
  */
	$scope.deleteEntry = function (index) {
		if (index > -1) {
			// Only remove a location if a true is returned from the function check ...
			var loc = $scope.policyLocations[index];
			PolicyService.checkCanRemoveLocation($scope.policyNumber, loc.publicID).then(function (data) {
				if (data === false) {
					//Class codes exist on this location hence it may NOT be removed.
					ModalService.showInfo($filter('translate')('gateway.controllers.policy.policychange.cannotRemoveLocationTitle'), $filter('translate'), 'gateway.controllers.policy.policychange.cannotRemoveLocationMsg');
				} else {
					//else return true from this function
					//ctrl.saveChanges($scope.policyLocations[index], 'delete');
					//$scope.policyLocations.splice(index, 1);
					$scope.policyLocations[index].actionType = 'delete';
					$scope.selectedEntry = -1;
					if ($scope.policyLocations.length <= 1) {
						$scope.cancelRemove();
					}
				}
				(function () {
					console.log("function deleteEntry - There was an error removing a location or  determining if there are class codes associated with the selected location..");
				});
			});
		}
	};

	/**
  * Stop removing entries
  */
	$scope.cancelRemove = function () {
		$scope.isRemoving = false;
	};
	/**
  * Cancel the new entry form
  */
	$scope.cancelNewEntry = function () {
		$scope.isAddingNew = false;
	};

	$scope.updateNameInsuredAddress = function (locationsForm) {
		console.log('locationform', locationsForm);
		locationsForm.submitted = true;
		$scope.contact = true;
		$scope.worksubmitted = false;
		$scope.isEditing = false;
	};

	/**
  * Submit the new entry form
  */
	$scope.submitNewEntry = function (locationsForm) {
		locationsForm.submitted = true;
		$scope.worksubmitted = false;
		if (locationsForm.$invalid) {
			$scope.worksubmitted = true;
			return $scope.worksubmitted;
		}

		var phoneNumber = angular.element('#phone').val();

		if (phoneNumber != undefined && phoneNumber != null && phoneNumber.trim() != '') {
			$scope.selectedLocation.phoneExtension = phoneNumber.split('x')[1].trim().replace(/\D/g, '');
			$scope.selectedLocation.phone = phoneNumber.split('x')[0].trim().replace(/\D/g, '');
		}

		$scope.selectedLocation.actionType = 'add';
		$scope.policyLocations.push($scope.selectedLocation);
		$scope.isAddingNew = false;
		//ctrl.saveChanges($scope.selectedLocation, 'add');
		//A successful addition is completed...So let's set the flag for newAddition to true...
		$scope.newAddition = true;
	};

	//function to force user to make a decision after quoting policy change.
	$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
		// Prevent users from entering the transaction screen by clicking back button -	DEF0618
		if (($rootScope.allowPolicyChangeEvent == undefined || !$rootScope.allowPolicyChangeEvent) && toState.name == 'newPolicyChange') {
			event.preventDefault();
			$window.history.forward(); // restrict navigation to the policy transaction page
		}

		if ($rootScope.restrictNavigation) {
			event.preventDefault();
			ModalService.showError('', 'quoteandbind.common.config.FlowConfig.Please accept or withdraw the policy change transaction.');
		}
	});
	/**
  * Function : Update entry for the policyLocations form
  * @params{} - reads value from submitted policyLocations Form.
  * @returns{} - update $scope object.
  * @private
  **/
	$scope.updateEntry = function () {
		var phoneNumber = angular.element('#phone').val();
		if (phoneNumber != undefined && phoneNumber != null && phoneNumber.trim() != '') {
			$scope.policyLocations[$scope.selectedEntry].phoneExtension = phoneNumber.split('x')[1].trim().replace(/\D/g, '');
			$scope.policyLocations[$scope.selectedEntry].phone = phoneNumber.split('x')[0].trim().replace(/\D/g, '');
		}
		if (locationsForm.$invalid) {
			$scope.worksubmitted = true;
			return $scope.worksubmitted;
		}
		if ($scope.policyLocations[$scope.selectedEntry].actionType != 'add') {
			$scope.policyLocations[$scope.selectedEntry].actionType = 'edit';
		}
		$scope.isEditing = false;
		$scope.selectedEntry = -1;
	};

	/**
  * Stop editing an entry
  */
	$scope.cancelEdit = function () {
		$scope.isEditing = false;
		if ($scope.selectedEntry !== -1) {
			var selectedLocation = $scope.policyLocations[$scope.selectedEntry];
			Object.assign(selectedLocation, $scope.modelBackup);
		}
		$scope.selectedEntry = -1;
	};

	/**
  * Resets all of the flags to their default false state
  */
	ctrl.resetFlags = function () {
		$scope.isRemoving = false;
		$scope.isReplacing = false;
		$scope.isEditing = false;
		$scope.isAddingNew = false;
		$scope.selectedEntry = -1;
	};

	/**
  * Function : Populates a new entry with default values for use in the new entry form
  * @params{}
  * @returns{} - sets $scope.selectedLocation to the default VM value to enable new location addition.
  * @private
  **/
	function setDefaultNewEntry() {
		if ($scope.policyLocations.length > 0) {
			//let's get the correct number so that there no duplication
			var origVal = $scope.policyLocations[$scope.policyLocations.length - 1].locationNum;
			$scope.newDefaultLocationNum = origVal + 1;
		} else {
			$scope.newDefaultLocationNum = 1;
		}
		var location = {
			locationNum: $scope.newDefaultLocationNum,
			state: 'MT'
		};
		$scope.locationView = ViewModelService.create(location, 'pc', 'edge.capabilities.address.dto.MSFPolicyLocationDTO');
		$scope.selectedLocation = $scope.locationView.value;
	}
	/*rounding to two decimal  */
	function roundToTwo(num) {
		return +(Math.round(num + "e+2") + "e-2");
	}
	function formatDate(date) {
		var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		//Finding whether the day is last day of the month
		var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
		console.log('last day');
		console.log(lastDayOfMonth);
		if (date.getDate() == lastDayOfMonth) {
			if (date.getMonth() == 11) {
				var year = date.getFullYear() + 1;
				var monthIndex = 0;
				var day = 1;
			} else {
				var monthIndex = date.getMonth() + 1;
				console.log(monthIndex);
				var day = 1;
				var year = date.getFullYear();
			}
		} else {
			var day = date.getDate() + 1;
			var monthIndex = date.getMonth();
			var year = date.getFullYear();
		}
		return day + ',' + monthNames[monthIndex] + ',' + year;
	}
	/**
  * Function : Function to save policyLocations on the scope object
  * @params{None}
  * @returns{object} - updates $scope.policyLocations
  * @private
  **/
	$scope.saveChangesForNext = function () {
		var modifiedLocations = _.filter($scope.policyLocations, function (policyLocation) {
			return policyLocation.actionType != undefined;
		});
		$scope.savePromise = PolicyService.locationChangeForPolicyChange($scope.jobNumber, modifiedLocations, '').then(function (data) {
			if (data != undefined) {
				$scope.policyLocations = data;
			}
		}, function () {
			ModalService.showError('gateway.controllers.policy.policychangectrl.Unable to save submission', 'gateway.controllers.policy.policychangectrl.locationError');
		});
	};
	/**
  * Function : save changes to modified location based on JobNumber and modified Locations
  * @params{None}
  * @returns{None}
  * @private
  **/
	$scope.saveChanges = function () {
		var modifiedLocations = _.filter($scope.policyLocations, function (policyLocation) {
			return policyLocation.actionType != undefined;
		});
		if ($scope.selectedData[0] === 'Edit Mailing Address') {
			$scope.savePromise = PolicyService.editMailingAddressforPolicyChange_EXT($scope.jobNumber, $scope.namedInsuredMailingAddress.value).then(function (data) {
				if (data != undefined) {
					$scope.mailingNewValue = data.displayName;
					$scope.namedInsuredMailingAddress.value = data;
					$scope.quoteAndBindPolicyChange();
				}
			}, function () {
				ModalService.showError('policy.common.controllers.policychangectrl.Unable to Save', 'policy.common.controllers.policychangectrl.locationError');
			});;
		} else {
			/**
          * Function : save changes to modified location based on JobNumber and modified Locations
          * @params{String, Array} - jobNumber and modifiedLocations List
          * @returns{None}
          * @private
          **/
			$scope.savePromise = PolicyService.locationChangeForPolicyChange($scope.jobNumber, modifiedLocations, '').then(function (data) {
				if (data != undefined) {
					$scope.policyLocations = data;
					$scope.quoteAndBindPolicyChange();
				}
			}, function () {
				ModalService.showError('gateway.controllers.policy.policychangectrl.Unable to save submission', 'gateway.controllers.policy.policychangectrl.locationError');
			});
		}
	};
};

fn.$inject = ['$window', '$translate', '$scope', '$rootScope', '$state', '$filter', '$q', '$stateParams', 'ModalService', 'PolicyService', 'ViewModelService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/policy/PolicyChangeCtrl.js
// module id = 1707
// module chunks = 0